/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  FetchIssuerMetadataRequestBody,
  FetchIssuerMetadataRequestBody$Outbound,
  FetchIssuerMetadataRequestBody$outboundSchema,
} from "../components/fetchissuermetadatarequestbody.js";

export type FetchGlobalRemoteSessionIssuerMetadataSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type FetchGlobalRemoteSessionIssuerMetadataRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  fetchIssuerMetadataRequestBody: FetchIssuerMetadataRequestBody;
};

/** @internal */
export type FetchGlobalRemoteSessionIssuerMetadataSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const FetchGlobalRemoteSessionIssuerMetadataSecurity$outboundSchema:
  z.ZodMiniType<
    FetchGlobalRemoteSessionIssuerMetadataSecurity$Outbound,
    FetchGlobalRemoteSessionIssuerMetadataSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function fetchGlobalRemoteSessionIssuerMetadataSecurityToJSON(
  fetchGlobalRemoteSessionIssuerMetadataSecurity:
    FetchGlobalRemoteSessionIssuerMetadataSecurity,
): string {
  return JSON.stringify(
    FetchGlobalRemoteSessionIssuerMetadataSecurity$outboundSchema.parse(
      fetchGlobalRemoteSessionIssuerMetadataSecurity,
    ),
  );
}

/** @internal */
export type FetchGlobalRemoteSessionIssuerMetadataRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  FetchIssuerMetadataRequestBody: FetchIssuerMetadataRequestBody$Outbound;
};

/** @internal */
export const FetchGlobalRemoteSessionIssuerMetadataRequest$outboundSchema:
  z.ZodMiniType<
    FetchGlobalRemoteSessionIssuerMetadataRequest$Outbound,
    FetchGlobalRemoteSessionIssuerMetadataRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      fetchIssuerMetadataRequestBody:
        FetchIssuerMetadataRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        fetchIssuerMetadataRequestBody: "FetchIssuerMetadataRequestBody",
      });
    }),
  );

export function fetchGlobalRemoteSessionIssuerMetadataRequestToJSON(
  fetchGlobalRemoteSessionIssuerMetadataRequest:
    FetchGlobalRemoteSessionIssuerMetadataRequest,
): string {
  return JSON.stringify(
    FetchGlobalRemoteSessionIssuerMetadataRequest$outboundSchema.parse(
      fetchGlobalRemoteSessionIssuerMetadataRequest,
    ),
  );
}
